import { PostgrestResponse } from '@supabase/supabase-js';
import { IVwVendasHoje } from '../../../types/views/IVwVendasHoje';
import { BaseMultiTenantService } from '../base/BaseMultiTenantService';

/**
 * View para vendas de hoje com dados otimizados
 * Corresponde à view 'vw_vendas_hoje' no banco de dados
 */
export class ViewVendasHoje extends BaseMultiTenantService<IVwVendasHoje[]> {
     constructor() {
          super('vw_vendas_hoje', [], 'organizacao');
     }

     /**
      * Busca todas as vendas de hoje
      */
     async getVendasHoje(organizationId: number): Promise<PostgrestResponse<IVwVendasHoje[]>> {
          return await this.getAllActive(organizationId);
     }

     /**
      * Busca vendas por aluno
      */
     async getVendasPorAluno(organizationId: number, alunoId: number): Promise<PostgrestResponse<IVwVendasHoje[]>> {
          return await this.client
               .from(this.tableName)
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .eq('id_aluno', alunoId)
               .order('data_venda', { ascending: false });
     }

     /**
      * Busca vendas por responsável
      */
     async getVendasPorResponsavel(organizationId: number, responsavelId: number): Promise<PostgrestResponse<IVwVendasHoje[]>> {
          return await this.client
               .from(this.tableName)
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .eq('id_responsavel', responsavelId)
               .order('data_venda', { ascending: false });
     }

     /**
      * Busca vendas pendentes
      */
     async getVendasPendentes(organizationId: number): Promise<PostgrestResponse<IVwVendasHoje[]>> {
          return await this.client
               .from(this.tableName)
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .eq('status_venda', 'pendente')
               .order('data_venda', { ascending: true });
     }

     /**
      * Total de vendas de hoje
      */
     async getTotalVendasHoje(organizationId: number): Promise<number> {
          const { data } = await this.client
               .from(this.tableName)
               .select('valor_final.sum()')
               .eq(this.organizationIdField, organizationId);

          return data?.[0]?.sum || 0;
     }
}

export const viewVendasHoje = new ViewVendasHoje();
